import React from 'react';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import {
  MdPickCarouselItem,
  MenuCarouselItem,
  SwiperBannerItem,
  swiperItemPropTypes,
  SwiperNavigatorItem,
  StyledComponent,
} from '@ecp/common/src/components/swiper/component/SwiperItem';
import StyledImg from '@ecp/common/src/components/image/StyledImg';

const TabWrapper = styled(StyledComponent.StyledRoot)`
  justify-content: center;
  align-items: center;
  width: fit-content;
  font-size: ${boTheme.font.size.small};
  font-weight: ${boTheme.font.weight.regular};
  color: ${boTheme.color.sub6};
  background: ${boTheme.color.sub9};
  border-top: 1px solid ${boTheme.color.sub7};
  border-bottom: 1px solid ${boTheme.color.sub5};
  box-sizing: border-box;

  &.carousel-item--selected {
    font-weight: ${boTheme.font.weight.bold};
    color: ${boTheme.color.main};
    background: ${boTheme.color.sub10};
    border-top: 3px solid ${boTheme.color.main};
    border-left: 1px solid ${boTheme.color.sub5};
    border-right: 1px solid ${boTheme.color.sub5};
    border-bottom: 0;
  }
`;

export const TabItem = ({ item, itemProps, ...props }) => {
  return (
    <TabWrapper {...itemProps} {...props}>
      {item.name}
    </TabWrapper>
  );
};

TabItem.propTypes = {
  ...swiperItemPropTypes,
};

const ImageViewWrapper = styled(StyledComponent.StyledRoot)`
  overflow: auto;
  display: block;
  position: inherit;

  ::-webkit-scrollbar-corner {
    background: rgba(0, 0, 0, 0);
  }
`;

const ImageContainer = styled.div`
  min-width: ${({ width }) => width ?? 'fit-content'};
  min-height: ${({ height }) => height ?? 'fit-content'};
  width: fit-content;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
`;

export const ImageViewItem = ({ item, itemProps, ...props }) => (
  <ImageViewWrapper {...itemProps} {...props}>
    <ImageContainer {...itemProps}>
      {itemProps.objectFit ? (
        <StyledImg src={item.url} alt={item.title} {...itemProps} />
      ) : (
        <StyledImg src={item.url} alt={item.title} />
      )}
    </ImageContainer>
  </ImageViewWrapper>
);

ImageViewItem.displayName = 'ImageViewItem';

ImageViewItem.propTypes = swiperItemPropTypes;

export { SwiperBannerItem, SwiperNavigatorItem, MdPickCarouselItem, MenuCarouselItem };
